/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

import Illustration from '../assets/images/Advantages/types-of-meetings.png';

export default function Advantage() {
  const bullets = [
    {
      title: '5-Minute Response',
      desc: "When you're a FAJTech client, you'll get a real human response to your support needs — faster.",
    },
    {
      title: 'Guaranteed Service',
      desc: 'We stand behind all of our work for every one of our clients. No excuses, 100% of the time.',
    },
    {
      title: 'Dedicated Client Success Manager',
      desc: 'Your Dedicated Client Success Manager ensures personalized support, proactive communication, and seamless IT solutions tailored to your business needs.',
    },
  ];

  return (
    <section className="py-24 bg-premium-light relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row lg:space-x-16 items-center">

          {/* LEFT: IMAGE */}
          <Fade direction="left" triggerOnce className="w-full lg:w-6/12">
            <div className="w-full rounded-3xl overflow-hidden group">
              <img
                src={Illustration}
                alt="IT Team"
                className="w-full h-full object-cover rounded-3xl shadow-glass-lg transition-all duration-500 group-hover:shadow-green-glow"
              />
            </div>
          </Fade>

          {/* RIGHT: CONTENT */}
          <div className="w-full lg:w-6/12 flex flex-col justify-center mt-12 lg:mt-0">

            <Fade direction="up" triggerOnce>
              <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4 w-fit">
                Why Choose Us
              </span>
              <h2 className="text-3xl lg:text-4xl font-extrabold text-surface-900 tracking-tight mb-4">
                What&apos;s Different About Our IT Support Company?
              </h2>

              <p className="text-surface-300 text-lg mb-10">
                You&apos;ll feel more confident in the value we provide to your business:
              </p>
            </Fade>

            {/* BULLETS */}
            <Fade direction="up" triggerOnce>
              <ul className="space-y-8">
                {bullets.map((item) => (
                  <li key={item.title} className="flex items-start space-x-4">
                    <div className="green-dot mt-1.5" />
                    <div>
                      <p className="font-semibold text-lg text-surface-900">{item.title}</p>
                      <p className="text-surface-300 mt-1 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </Fade>

          </div>
        </div>
      </div>
    </section>
  );
}
